
(function ($, undefined) {
	'use strict';

	let addNewLocationTitle;
	let addNewLocationForm;
	let formValidator;
	let utils;

	const init = () => {
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		if (window.location.pathname === '/users/add')
			getPolygonalCoordinates();
		addNewLocationTitle = $('.add-new-location-title');
		addNewLocationForm = $('.add-new-location-form');

		// Initialize Select2 on location and buttons dropdowns for themed highlight
		var locationSelect = $('#add-user-form-location-select');
		var buttonsSelect = $('#add-user-form-access-select');
		if (window.initializeSelect2) {
			window.initializeSelect2(locationSelect);
			window.initializeSelect2(buttonsSelect);
		}

		$('[name="location"]', addNewLocationForm).on('change', onLocationChange);
		$('[name="buttons"]', addNewLocationForm).on('change', onButtonsChange);
		$('.add-new-location-btn').on('click', onNewLocationClick);

		$('.save-location-btn').on('click', () => { onSaveLocationClick('save') });
		$('.close-location-btn').on('click', () => { onSaveLocationClick(null) });

		$('input[name="sendGeofenceReportEmail"]').on('change', function () {
			$(this).val(this.checked);
		});

		$(document).ready(function () {
			$('input[name="allowGeofencing"]').on('change', function () {
				$(this).val(this.checked);
				if (this.checked) {
					$("#geofence-list").addClass("sb-d-block").removeClass("d-none");
				} else {
					$("#geofence-list").removeClass("sb-d-block").addClass("d-none");
				}
			}).trigger('change'); // 🔹 This makes it run on page load
		});

		$('input[name="field40Checkbox"]').on('change', function () {
			$('input[name="field40"]').val(this.checked);
			$(this).val(this.checked);
		});

		$('.add-user-delete-location').on('click', onUserLocationDelete);
		$('.add-user-edit-location').on('click', onUserLocationEdit);

		$('.add-user-delete-button').on('click', onUserLocationButtonDelete);

		$('.add-user-form').on('submit', submitForm);
		$('.add-user-demo-btn').on('change', updateFormField5);

		var checkboxKera = document.getElementById("field21Checkbox");
		var hiddenInputKera = document.getElementById("field21Hidden");
		var checkboxSearchKera = document.getElementById("field12Checkbox");
		var hiddenSearchInputKera = document.getElementById("field12Hidden");
		var checkboxSSO = document.getElementById("field40Checkbox");
		var hiddenInputSSO = document.getElementById("field40Hidden");

		if (hiddenInputKera && checkboxKera) {
			checkboxKera.addEventListener("change", function () {
				hiddenInputKera.value = checkboxKera.checked ? "true" : "false";
			});
		}

		if (hiddenSearchInputKera && checkboxSearchKera) {
			checkboxSearchKera.addEventListener("change", function () {
				hiddenSearchInputKera.value = checkboxSearchKera.checked ? "true" : "false";
			});
		}

		if (hiddenInputSSO && checkboxSSO) {
			checkboxSSO.addEventListener("change", function () {
				hiddenInputSSO.value = checkboxSSO.checked ? "true" : "false";
			});
		}


	};

	function onNewLocationClick() {
		openLocationForm();
		addNewLocationForm.find("#geofence-list").css("display", 'none');
		addNewLocationForm.find("#geofence-list-inner").html("");
		addNewLocationForm.removeAttr('data-id');
		addNewLocationForm.find('[name="location"]').prop('disabled', false).val('');
		addNewLocationForm.find('[name="buttons"]').val('');

		var userType = $('#add-user-form-role-input').find(":selected").val();
		addNewLocationForm.find('[name="all-property-buttons"]').prop('checked', userType == "1" || userType == "3");
		addNewLocationForm.find('[name="all-security-buttons"]').prop('checked', userType == "6" || userType == "7");
		clearButtons();
	}

	function clearButtons() {
		addNewLocationForm.find('.add-modify-page-inner-item-ctn-edit-item:not(.add-modify-page-inner-item-ctn-edit-item_template)').remove();
	}

	function onSaveLocationClick(btnName) {
		const dataEdit = addNewLocationForm.attr('data-edit');

		if (dataEdit == 'true' || btnName == 'save') {
			const id = addNewLocationForm.attr('data-id');
			const locationId = addNewLocationForm.find('[name="location"]').val();

			let clone;
			let isClone;

			closeLocationForm();

			formValidator.validateForm(addNewLocationForm);

			if (addNewLocationForm.hasClass('has-error')) {
				return;
			}

			clone = $('.add-modify-page-inner-item-ctn-location-item_template').clone().removeClass("add-modify-page-inner-item-ctn-location-item_template");
			var ll = locationId && locationId.length > 0 ? locationId.substring(0, locationId.indexOf(":")) : "0";
			// clone.find('.first').html("<a href=\"locations/add/analytics?gid="+ll+"\" target=\"_blank\">"+addNewLocationForm.find('[name="location"] option:selected').text()+"</a>");
			clone.find('.first').html("<a href=\"locations/add?gid=" + ll + "\" target=\"_blank\">" + addNewLocationForm.find('[name="location"] option:selected').text() + "</a>");
			clone.attr('data-id', locationId);
			clone.attr('data-access', JSON.stringify(getAccessJSON(addNewLocationForm)));
			clone.attr('geofence-data', JSON.stringify(getGeofenceJSON(addNewLocationForm)));
			clone.find('.add-user-delete-location').on('click', onUserLocationDelete);
			clone.find('.add-user-edit-location').on('click', onUserLocationEdit);

			addNewLocationForm.find('[name="location"] option:selected').remove();
			addNewLocationForm.removeAttr('data-edit');

			$('.add-modify-page-inner-item-ctn-location').append(clone);

			enableLocationSelector();
			clearButtons();
			disableButtonsSelector();
			addUserToLocation(locationId.split(":")[0]);
		} else {
			closeLocationForm();
			$("#add-user-form-location-select").val("").trigger('change');
		}
	}

	function addUserToLocation(id) {
		let idInput = document.querySelector('[name="id"]');
		if (idInput) {
			let resolveRef;
			let promise = new Promise(resolve => resolveRef = resolve);

			utils.fetchGenDatas({ id, json: true }, gds => {
				if (typeof gds == 'object') {
					let locId = "#y" + id;
					let locInp = $("#y" + id);
					var field10 = locInp != undefined && locInp.length > 0 ? locInp.val().split(",") : gds[0] && gds[0].field10 && gds[0].field10.split(',') || [];

					if (field10.indexOf(idInput.value) == -1) {
						field10[field10.length] = idInput.value;
					}

					if (locInp != undefined && locInp != null && locInp.length > 0) {
						locInp.val(field10.join());
						resolveRef();
					} else {
						$(".add-user-form").append("<input type='hidden' id='" + (locId.replace("#", "")) + "' class='locs-with-users' loc-id='" + id + "' value='" + field10.join() + "'/>");
						resolveRef();
					}
				} else {
					resolveRef();
				}
			});

			return promise;
		} else {
			console.log("Resolving automatically");
			return Promise.resolve();
		}
	}

	function getPolygonalCoordinates() {


		const domain = window.location.hostname;
		let url = "";
		const params = new URLSearchParams(window.location.search)

		if (domain === "localhost") {
			url = `http://localhost:9105`;
		} else {
			url = `/geofence-service`;
		}

		$.ajax({
			url: `${url}/public/get-polygonal-coordinates?personId=${$('#geofencePersonId').val()}&userId=${params.get('personId')}`,
			complete: (res) => {
				var response = res.responseText;

				if (response) {

					let parsed = JSON.parse(response); // parse the full JSON string

					let geofences = parsed.geofences; // access the location-specific geofences

					if (!Array.isArray(geofences)) throw new Error("Invalid format");

					if (geofences.length > 0) {

						setTimeout(() => {

							const button = document.querySelector('button[modal-id="geofence-modal"]');

							if (button) {
								button.innerHTML = `
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" width="23" height="23"><path d="M22.3,0.7c-0.9-0.9-2.5-0.9-3.4,0l0,0l-0.8,0.8c-0.7-0.3-1.5-0.1-2.1,0.4L1.5,16.4     c-0.1,0.1-0.2,0.2-0.2,0.4L0,22c-0.1,0.4,0.2,0.9,0.6,1c0.1,0,0.1,0,0.2,0H1l5.2-1.2c0.1,0,0.3-0.1,0.4-0.2L21.1,7.1     c0.6-0.5,0.7-1.4,0.4-2.1l0.8-0.8C23.3,3.2,23.3,1.7,22.3,0.7L22.3,0.7L22.3,0.7z M21.2,1.8c0.3,0.3,0.3,0.8,0,1.1c0,0,0,0,0,0l0,0     l-0.7,0.7l-1.1-1.1L20,1.8C20.3,1.5,20.9,1.5,21.2,1.8z M10.7,12.3c0.3,0.3,0.8,0.3,1.1,0l4.6-4.6l0.8,0.8L6,19.8L3.2,17L14.5,5.7     l0.8,0.8l-4.6,4.6C10.4,11.4,10.4,11.9,10.7,12.3L10.7,12.3z M2.5,18.6l1.9,1.9l-2.5,0.6L2.5,18.6z M19.9,5.9l-1.4,1.4l-2.9-2.8     l1.4-1.4c0.1-0.1,0.3-0.1,0.4,0L20,5.5C20.1,5.6,20.1,5.8,19.9,5.9L19.9,5.9z"></path></svg> Add-Edit`;
							}

						}, 1000);

					}
					else {

						setTimeout(() => {

							const button = document.querySelector('button[modal-id="geofence-modal"]');

							if (button) {
								button.innerHTML = `
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.3 70.3" width="70.3" height="70.3"><path d="M35.1,70.3C15.7,70.3,0,54.5,0,35.1C0,15.7,15.7,0,35.1,0c19.4,0,35.1,15.7,35.1,35.1c0,0,0,0,0,0     C70.2,54.5,54.5,70.2,35.1,70.3z M35.1,4.8C18.4,4.8,4.8,18.4,4.8,35.1s13.6,30.4,30.4,30.4c16.8,0,30.4-13.6,30.4-30.4     C65.5,18.4,51.9,4.8,35.1,4.8z M50.2,33.4h-13v-13c0-1.2-0.9-2.1-2.1-2.1c0,0,0,0,0,0l0,0c-1.2,0-2.1,0.9-2.1,2.1c0,0,0,0,0,0v13     h-13c-1.2,0-2.1,0.9-2.1,2.1c0,0,0,0,0,0l0,0c0,1.2,0.9,2.1,2.1,2.1c0,0,0,0,0,0h13v13c0,1.2,0.9,2.1,2.1,2.1c0,0,0,0,0,0l0,0     c1.2,0,2.1-0.9,2.1-2.1c0,0,0,0,0,0v-13h13c1.2,0,2.1-0.9,2.1-2.1c0,0,0,0,0,0l0,0C52.4,34.4,51.4,33.4,50.2,33.4     C50.3,33.4,50.2,33.4,50.2,33.4z"></path></svg> Add New`;
							}

						}, 1000);
					}
				}
			},
			error: (res) => {
				console.log(res);
			}
		});
	}


	function getGeofenceJSON(ele) {
		let geofences = []
		// ele.find('.add-modify-page-inner-geofence-ctn-location-item').map((i, el) => {
		// 	geofences.push({ coords: $(el).attr("geofence-data") == "" ? "" : JSON.parse($(el).attr("geofence-data")), name: $(el).find(".first").html() });
		// });

		return ({ geofences });
	}

	function getAccessJSON(ele) {
		const allProperty = ele.find('[name="all-property-buttons"]').prop('checked');
		const allSecurity = ele.find('[name="all-security-buttons"]').prop('checked');
		const ids = ele.find('.add-modify-page-inner-item-ctn-edit-item:not(add-modify-page-inner-item-ctn-edit-item_template)').map((i, el) => {
			return el.dataset.id;
		}).get().join();

		return ({
			ids,
			all: (allProperty && allSecurity),
			allProperty,
			allSecurity
		});
	}

	function openLocationForm() {
		$(".add-new-location-btn").hide();
		addNewLocationTitle.show(300);
		addNewLocationForm.show(300);
	}

	function closeLocationForm() {
		$(".add-new-location-btn").show();
		addNewLocationTitle.hide(300);
		addNewLocationForm.hide(300);
	}

	function onUserLocationDelete({ currentTarget }) {
		const item = $(currentTarget).closest('.add-modify-page-inner-item-ctn-location-item');
		const idFull = item.attr('data-id');
		const id = idFull.split(":")[0];
		let option = $(`<option value="${idFull}">${item.text()}</option>`);

		$('[name="location"]').append(option);
		$(currentTarget).closest('.add-modify-page-inner-item-ctn-location-item').remove();

		removeUserFromLocation(id);
	}

	function removeUserFromLocation(id) {
		let idInput = document.querySelector('[name="id"]');
		if (idInput) {
			utils.fetchGenDatas({ id, json: true }, gd => {
				if (typeof gd == 'object') {
					const userId = $('[name="id"]').val();

					let locId = "#y" + id;
					let locInp = $("#y" + id);
					var field10 = locInp != undefined && locInp.length > 0 ? locInp.val().split(",") : gd[0].field10.split(',') || [];

					if (field10.indexOf(idInput.value) == -1) {
						field10[field10.length] = idInput.value;
					}

					const index = field10.indexOf(userId);
					if (index != -1) {
						field10.splice(index, 1);
					}

					if (locInp != undefined && locInp != null && locInp.length > 0) {
						locInp.val(field10.join());
					} else {
						$(".add-user-form").append("<input type='hidden' id='" + (locId.replace("#", "")) + "' class='locs-with-users' loc-id='" + id + "' value='" + field10.join() + "'/>");
					}
				}
			});
		}
	}

	function onUserLocationEdit({ currentTarget }) {
		const item = $(currentTarget).closest('.add-modify-page-inner-item-ctn-location-item');
		const id = item.attr('data-id');
		const newId = id.split(":")[0];
		const isGeofenceAllowed = id.split(":")[1];
		const access = item.attr('data-access');
		const geofenceData = item.attr('geofence-data') == undefined || item.attr('geofence-data').length <= 0 ? null : JSON.parse(item.attr('geofence-data'));
		const buttons = addNewLocationForm.find('[name="buttons"]');
		const locations = addNewLocationForm.find('[name="location"]');

		window.parent.geofenceDataCollection = {
			geofenceData: geofenceData,
			newId: newId
		};

		item.remove();
		locations.append(`<option value="${id}">${item.text()}</option>`);

		if (addNewLocationForm.attr('data-edit') == 'true') {
			onSaveLocationClick('save');
		}

		$("#geofence-list-inner").html("");

		if ((geofenceData != null || geofenceData != undefined) && geofenceData.geofences.length > 0) {
			geofenceData.geofences.forEach((v) => {
				window.parent.cloneCoordsTemplate({ coords: JSON.stringify(v.coords), name: v.name });
			});
		}

		var selected = $('#add-user-form-role-input').find(":selected").val();
		updateSecUserEle(selected, isGeofenceAllowed);

		addNewLocationForm.attr('data-edit', true);
		addNewLocationForm.find('[name="location"]').val(id);
		addNewLocationForm.find('[name="buttons"]').val('');
		disableLocationSelector();
		clearButtons();

		fetchButtons(newId).then(() => {
			if (typeof access != 'undefined') {
				const json = JSON.parse(access);
				const ctn = $('.add-modify-page-inner-item-ctn-edit-ctn');
				json.ids.toString().split(',')
					.forEach(id => {
						if (!id.length) return;
						const clone = $('.add-modify-page-inner-item-ctn-edit-item_template').clone(true, true).removeClass('add-modify-page-inner-item-ctn-edit-item_template');

						clone.attr('data-id', id);
						clone.find('.add-modify-page-inner-item-ctn-edit-item__text div').text(buttons.find(`option[value="${id}"]`).text());
						ctn.append(clone);
						buttons.find(`option[value="${id}"]`).remove();
					});

				var userType = $('#add-user-form-role-input').find(":selected").val();
				addNewLocationForm.find('[name="all-property-buttons"]').prop('checked', ((!('all' in json) || !('allProperty' in json)) && (userType == "1" || userType == "3")) || json.all == 'true' || json.all == true || json.allProperty == 'true' || json.allProperty == true);
				addNewLocationForm.find('[name="all-security-buttons"]').prop('checked', ((!('all' in json) || !('allSecurity' in json)) && (userType == "6" || userType == "7")) || json.all == 'true' || json.all == true || json.allSecurity == 'true' || json.allSecurity == true);
			}
		});

		openLocationForm();
	}

	function disableLocationSelector() {
		$('[name="location"]').prop('disabled', true);
	}

	function disableButtonsSelector() {
		$('[name="buttons"]').prop('disabled', true);
	}

	function enableLocationSelector() {
		$('[name="location"]').prop('disabled', false);
	}

	function onLocationChange({ currentTarget }) {
		let isGeofenceAllowed = currentTarget.value.split(":")[1];
		let locId = currentTarget.value.split(":")[0];

		var selected = $('#add-user-form-role-input').find(":selected").val();

		updateSecUserEle(selected, isGeofenceAllowed);

		fetchButtons(locId);
	}

	function onButtonsChange({ currentTarget }) {
		const id = currentTarget.value;

		const button = $('.add-modify-page-inner-item-ctn-edit-item_template');
		const index = currentTarget.selectedIndex;

		const selected = currentTarget.options[index];
		const clone = button.clone(true, true).removeClass('add-modify-page-inner-item-ctn-edit-item_template');
		currentTarget.removeChild(selected);
		currentTarget.value = "";

		clone.attr('data-id', id);
		clone.find('.add-modify-page-inner-item-ctn-edit-item__text div').text(selected.text);
		$('.add-modify-page-inner-item-ctn-edit-ctn').append(clone);
	}

	function fetchButtons(id) {
		let resolveRef;
		let promise = new Promise(resolve => resolveRef = resolve);
		const select = $('[name="buttons"]');
		select.prop('disabled', false);
		select.parent().addClass('has-processing has-processing_active');
		select.find('option:not([value=""])').remove();

		if (id.length) {
			utils.getPerson((person) => {
				if (typeof person !== 'string') {
					var assObj = person.addInfo7 && person.addInfo7 != '' ? JSON.parse(person.addInfo7)[id] : undefined;

					var ids = assObj != undefined && assObj.ids != '' ? assObj.ids : '';
					var all = assObj != undefined && assObj.all != '' ? assObj.all : false;
					var allSecurity = assObj != undefined && assObj.allSecurity != undefined ? assObj.allSecurity : false;
					var allProperty = assObj != undefined && assObj.allProperty != undefined ? assObj.allProperty : false;

					var loggedUserRole = $("#loggedUserRole").val();

					var options = { field1: 'button', field15: id };
					if (loggedUserRole == 6 && !allSecurity && !all && ids != '')
						options = { field1: 'button', ids, field15: id };

					utils.fetchGenDatas(options, (gds) => {
						if (typeof gds !== 'string') {
							gds.forEach(gd => {
								if (loggedUserRole == 6) {
									if (assObj != undefined && (all == true || (allProperty == true && allSecurity == true))) {
										select.append(`<option value="${gd.id}">${decodeCMSEncoding(gd.field2)}</option>`);
									} else if (assObj != undefined && allProperty == true && gd.field31 == 'false') {
										select.append(`<option value="${gd.id}">${decodeCMSEncoding(gd.field2)}</option>`);
									} else if (assObj != undefined && allSecurity == true && gd.field31 == 'true') {
										select.append(`<option value="${gd.id}">${decodeCMSEncoding(gd.field2)}</option>`);
									} else if (ids != '') {
										select.append(`<option value="${gd.id}">${decodeCMSEncoding(gd.field2)}</option>`);
									} else if (allProperty == false && gd.field31 == 'true') {
										select.append(`<option value="${gd.id}">${decodeCMSEncoding(gd.field2)}</option>`);
									}
								} else if (loggedUserRole != 6)
									select.append(`<option value="${gd.id}">${decodeCMSEncoding(gd.field2)}</option>`);
							});
						}

						select.parent().removeClass('has-processing has-processing_active');
						resolveRef();
					});
				}
			});

			return promise;
		} else {
			select.parent().removeClass('has-processing has-processing_active');
			return Promise.resolve();
		}
	}

	function onUserLocationButtonDelete({ currentTarget }) {
		let button = $(currentTarget).closest('.add-modify-page-inner-item-ctn-edit-item');
		let id = button.attr('data-id');
		addNewLocationForm.find('[name="buttons"]').append(`<option value="${id}">${button.text()}</option>`);
		button.remove();
	}

	function submitForm(e) {
		const form = e.currentTarget;

		const $form = $(form);
		e.preventDefault();
		formValidator.validateForm($form);
		// Check password match
		const passwordValid = formValidator.validatePasswordRestrictions($('[name=password]', $form).val());
		const passwordIsEmpty = $('[name=password]', $form).val() === '';
		if (!passwordValid && !passwordIsEmpty) {
			$form.addClass('has-error');
			$('[name=password]', $form).addClass('error');
		}

		if (!$form.hasClass('has-error')) {
			$.ajax({
				url: '/action/checkDetailsIfExists?request=Person&includes=firstName,lastName&findBy=email&find=' + $form.find("input[name='email']").val(),
				type: 'GET',
				complete: (result) => {
					var json = result && result.responseJSON ? result.responseJSON : null;
					var data = json && json.data ? JSON.parse(json.data) : null;

					if (json.isAvailable == 'false' || ($("input[name='orignalEmail']").val() == $("input[name='email']").val() && $("input[name='id']").val() > 0)) {
						(() => {
							let resolveRef;
							var locsWithUser = $(".locs-with-users");
							let promise = new Promise(resolve => resolveRef = resolve);

							if (locsWithUser != undefined && locsWithUser.length > 0) {
								let dataObj = [];
								for (var i = 0; i < locsWithUser.length; i++) {
									var locWithUser = $(locsWithUser[i]);
									dataObj.push({ id: locWithUser.attr("loc-id"), field10: locWithUser.val() });
								}
								utils.updateGenDatas(dataObj, () => {
									resolveRef();
								});
							} else resolveRef();
							return promise;
						})().then(() => {
							const inputId = document.querySelector('[name="id"]');
							const items = document.querySelectorAll('.add-modify-page-inner-item-ctn-location-item:not(.add-modify-page-inner-item-ctn-location-item_template)');
							updateFormField7();

							if (!inputId && items.length) {
								$('.site-overlay').addClass('site-overlay_processing');
								$.ajax({
									url: '/action/createAccount',
									type: 'POST',
									data: {
										curPage: location.pathname,
										email: document.querySelector('[name="email"]').value,
										password: document.querySelector('[name="password"]').value,
										returnId: true,
										noEmail: true,
										field6: document.querySelector('[name="field6"]').value,
										field10: 'inactive',
										ajax: true,
										field7: $(form) && $(form).find("input[name='field7']") && $(form).find("input[name='field7']").length > 0 ? $(form).find("input[name='field7']").val() : null
									},
									complete: (res) => {
										if (res.responseText.indexOf('success-') > -1) {
											let id = res.responseText.trim().split('success-')[1];
											form.action = '/action/updatePerson';
											$(form).append(`<input type="hidden" name="id" value="${id}" />`);
											updateLocations().then(() => {
												(() => {
													let resolveRef;
													let promise = new Promise(resolve => resolveRef = resolve);
													var locsWithUser = $(".locs-with-users");
													if (locsWithUser != undefined && locsWithUser.length > 0) {
														let dataObj = [];
														for (var i = 0; i < locsWithUser.length; i++) {
															var locWithUser = $(locsWithUser[i]);
															dataObj.push({ id: locWithUser.attr("loc-id"), field10: locWithUser.val() });
														}
														utils.updateGenDatas(dataObj, () => {
															resolveRef();
														});
													} else resolveRef();
													return promise;
												})().then(() => {
													form.submit();
												});
											});
										} else {
											form.submit();
										}
									}
								});
							} else {
								form.submit();
							}
						});
					} else
						alert("Error - User email already exists.  You cannot use this email ID again.");
				}
			});
		}
	}

	function updateLocations() {
		let resolveRef;
		let promise = new Promise(resolve => resolveRef = resolve);
		let count = 0;
		let items = document.querySelectorAll('.add-modify-page-inner-item-ctn-location-item:not(.add-modify-page-inner-item-ctn-location-item_template)');
		function callback() {
			count++;
			if (count >= items.length) {
				resolveRef();
			}
		}

		for (var i = 0; i < items.length; i++) {
			let item = items[i];
			let id = item.dataset.id;

			addUserToLocation(id.split(":")[0]).finally(callback);
		}

		return promise;
	}

	function updateFormField5(e) {
		$('input[name="field5"]').val(e.currentTarget.checked);
		$('input[name^="expireDate"]').each((i, el) => {
			if (e.currentTarget.checked) {
				el.value = el.dataset.default;
			} else {
				switch (el.name) {
					case 'expireDateYear':
						el.value = 1970;
						break;
					case 'expireDateMonth':
						el.value = 0;
						break;
					case 'expireDateDay':
						el.value = 1;
						break;
				}
			}
		});
	}

	function updateFormField7() {
		let json = {};
		let polygonalCoordsJson = {};

		$('.add-modify-page-inner-item-ctn-location-item:not(add-modify-page-inner-item-ctn-location-item_template)').each((i, el) => {
			const access = el.dataset.access;
			var id = el.dataset.id;
			id = id == undefined ? null : id.split(":")[0];

			if (typeof access != 'undefined') {
				json[`${id}`] = JSON.parse(el.dataset.access);
				$('input[name="field7"]').val(JSON.stringify(json));
			} else console.warn("else typeof access != 'undefined'");

			const coords = $(el).attr("geofence-data");
			if (typeof coords != 'undefined') {
				polygonalCoordsJson[`${id}`] = JSON.parse(coords);
				$('input[name="polygonalCoords"]').val(JSON.stringify(polygonalCoordsJson));
			} else console.warn("else typeof coords != 'undefined' ");

		});
	}

	$('#add-user-form-role-input').on('select2:select', function (e) {
		var selectedLoc = $('#add-user-form-location-select').find(":selected").val();

		var locIdGeofence = selectedLoc != null && selectedLoc != undefined && selectedLoc != '' ? selectedLoc.split(":")[1] : null;

		var selected = $('#add-user-form-role-input').find(":selected").val();

		$('[name="all-property-buttons"]').prop('checked', selected == "1" || selected == "3");
		$('[name="all-security-buttons"]').prop('checked', selected == "6" || selected == "7");
		updateSecUserEle(selected, locIdGeofence);
	});

	$(window).ready(function () {
		init();
		var selectedLoc = $('#add-user-form-location-select').find(":selected").val();
		var locIdGeofence = selectedLoc != null && selectedLoc != undefined && selectedLoc != '' ? selectedLoc.split(":")[1] : null;
		var selected = $('#add-user-form-role-input').find(":selected").val();

		updateSecUserEle(selected, locIdGeofence);
	});

	function updateSecUserEle(selected, locIdGeofence) {
		console.warn("selectedLoc: " + locIdGeofence + ", selected: " + selected);
		if ($('input[name="allowGeofencing"]').is(':checked')) $("#geofence-list").addClass("sb-d-block").removeClass("d-none");
		else $("#geofence-list").removeClass("sb-d-block").addClass("d-none");

		if (selected == 7) $("input[name='allowGeofencing'").parent("label").parent("div").addClass("sb-d-block").removeClass("d-none");
		else {
			$('input[name="allowGeofencing"]').prop('checked', false);
			$("input[name='allowGeofencing'").parent("label").parent("div").removeClass("sb-d-block").addClass("d-none");
		}

		if (selected == 6 || selected == 1)
			$("input[name='sendGeofenceReportEmail'").parent("label").parent("div").addClass("sb-d-block").removeClass("d-none");
		else $("input[name='sendGeofenceReportEmail'").parent("label").parent("div").removeClass("sb-d-block").addClass("d-none");

		if (selected == 6 || selected == 1 || selected == 8) {
			$("input[name='field21Checkbox'").parent("label").parent("div").addClass("sb-d-block").removeClass("d-none");
			$("input[name='field12Checkbox'").parent("label").parent("div").addClass("sb-d-block").removeClass("d-none");
		}
		else {
			$("input[name='field21Checkbox'").parent("label").parent("div").removeClass("sb-d-block").addClass("d-none");
			$("input[name='field12Checkbox'").parent("label").parent("div").removeClass("sb-d-block").addClass("d-none");
		}
		if (!selected)
			$("input[name='field21Checkbox'").parent("label").parent("div").removeClass("sb-d-block").addClass("d-none");
	}
})(jQuery);